// extracted by mini-css-extract-plugin
export var cardContainer = "_mt-0";
export var cardHeader = "_mt-2";
export var collapsedState = "_mt-3";
export var dragHandle = "_mt-5";
export var dragHandleIcon = "_mt-6";
export var dragging = "_mt-1";
export var titleArea = "_mt-4";